// @ts-nocheck
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import SearchTextField, { SearchTextFieldStyles } from "@insite/content-library/Widgets/OrderHistory/SearchTextField";
import * as React from "react";
import translate from "@insite/client-framework/Translate";

export const searchItemNumberStyles: SearchTextFieldStyles = {};
const styles = searchItemNumberStyles;

const OrderHistorySearchByItemNumber: React.FunctionComponent<WidgetProps> = () => {
    return (
        <SearchTextField
            styles={styles}
            parameterField="itemNumber"
            label={translate("Item #")}
            inputType="text"
            placeholder=""
            testSelector="orderHistory_searchItemNumber"
        />
    );
};

const widgetModule: WidgetModule = {
    component: OrderHistorySearchByItemNumber,
    definition: {
        group: "Order History",
        displayName: "Item #",
        allowedContexts: ["OrderHistoryPage", "VmiOrderHistoryPage"],
    },
};

export default widgetModule;
